import React, { HTMLAttributes, FC } from 'react';
import { useStyles } from './styles';
import { cx } from '../customEmotion';
import { ColorProp } from '../types/color';

export interface TagProps extends Omit<HTMLAttributes<HTMLDivElement>, 'color'> {
	className?: string;
	color?: ColorProp;
	variant?: 'filled' | 'outlined';
}

const Tag: FC<TagProps> = ({
	children,
	className,
	color,
	variant,
	onClick,
	...props
}) => {
	const styles = useStyles([color, variant, !!onClick]);
	return (
		<div
			{...props}
			className={className ? cx(styles.tag, className) : styles.tag}
			onClick={onClick}
		>
			<span className={styles.label}>
				{children}
			</span>
		</div>
	);
};

Tag.defaultProps = {
	variant: 'filled',
};

export default Tag;
